import { useMediaQuery as useMediaQuery$ } from 'react-responsive';
export const media = {
  sm: 768,
  md: 970,
  lg: 1170,
};

// TODO: MK move hooks to separate ui library
const useMediaQuery: typeof useMediaQuery$ =
  typeof window === 'undefined' ? () => true : useMediaQuery$;

export const useMediaUpMd = () =>
  useMediaQuery({ query: `all and (min-width: ${media.md}px)` });

export const useMediaUpLg = () =>
  useMediaQuery({ query: `all and (min-width: ${media.lg}px)` });

export const useMediaDownSm = () =>
  useMediaQuery({ query: `all and (max-width: ${media.md - 1}px)` });

export const useMediaDownXs = () =>
  useMediaQuery({ query: `all and (max-width: ${media.sm - 1}px)` });

export const useMobile = () =>
  useMediaQuery$({ query: `(max-width: ${media.sm - 1}px)` });
